export class DivipolaI{
    id : BigInteger;
    coddepto : String;
    departamento : String;
    codmpio : String;
    nommpio : String;
}